import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import AnchorLiveFeedPlayer from '../AnchorLiveFeedPlayer/AnchorLiveFeedPlayer';
import BroadcastChat from '../../BroadcastChat/BroadcastChat';
import GroupShowStore from '../../../store/GroupShowStore';
import './css/AnchorLiveFeed.css';
import './css/AnchorLiveFeed.mobile.css';
import { RootStoreContext } from '../../../context';
import { status } from '../../../constants/sfwStatus';
import LiveBroadcastStore from '../../../store/LiveBroadcastStore';

import AnchorLiveFeedHeader from './AnchorLiveFeedHeader/AnchorLiveFeedHeader';


@observer
class AnchorLiveFeed extends React.PureComponent {
  static contextType = RootStoreContext;

  state = {
    broadcasterClosedSession: false,
    spotlighterClosedSession: false,
    nsfw: false,
    safeForWatchStatus: status.NO_STATUS,
    roomCount: 0,
    shouldCloseBroadCastPlayer: false,
    spotlightedByTemptationName: null,
  };

  roomUsersCountListener = (roomCount) => {
    this.setState({ roomCount: roomCount.count });
  };

  onBroadcasterClosedSession = () => {
    this.setState({ broadcasterClosedSession: true });
  };

  onLiveSessionEnd = () => {
    this.setState({ shouldCloseBroadCastPlayer: true });
  }

  onSpotlighterClosedSession = () => {
    this.setState({ spotlighterClosedSession: true });
  };

  changeNsfwFlag = (nsfw) => {
    if (!nsfw) {
      this.props.fetchStreamDetails();
    }
    this.setState({ nsfw, safeForWatchStatus: nsfw ? status.NSFW : status.SFW });
  };

  broadcastChatCallback = (streamingSourceType) => {
    this.setState({ streamingSourceType });
  };

  getStreamingSourceType = () => {
    const { anchorVideoUrl } = this.props;
    const {
      isInGroupShow,
      streamingSource,
    } = GroupShowStore;
    if (isInGroupShow) {
      return streamingSource;
    }

    return anchorVideoUrl.streamingSourceType;
  };

  setSpotlightedByTemptationName = (value) => {
    this.setState({ spotlightedByTemptationName: value });
  };

  render() {
    const {
      broadcasterClosedSession,
      safeForWatchStatus,
      roomCount,
      nsfw,
      spotlighterClosedSession,
      spotlightedByTemptationName,
    } = this.state;
    const {
      tippingStore: { setTippingModal },
      uiStore,
    } = this.context;
    const {
      anchor,
      anchorVideoUrl,
      user,
      chatService,
      chatServiceTempted,
      guestUser,
      anchorId,
      openContextualOverlay,
      isAnchor,
      canSubscribeToAnchor,
      isAlreadySubscribedToAnchor,
      slug,
      history,
      isBanned,
      isSpotlighing,
      spotlighedAnchorUsername,
      spotlighedAnchorNickname,
      isLivePage,
      isWhitelisted,
      toggleStreamLoading,
      shouldHideVolumeRange,
      isTulumRealityShow,
      onTulumStreamError,
      hasStreamError,
      onAllowStreamChangeOnError,
    } = this.props;
    const isGuest = !user.authenticated;
    const {
      isInGroupShow,
      publicChatService,
    } = GroupShowStore;
    const { isSpotlight, subscribedToOneOfTheAnchors, spotlightedByAnchorNickname } = LiveBroadcastStore;
    const hasStreamViews = anchorVideoUrl?.streamViews?.length > 0;
    const shouldShowLiveFeed = !this.state.shouldCloseBroadCastPlayer && (anchorVideoUrl && isWhitelisted) || isInGroupShow || isSpotlighing;
    const currentAnchorIsNotSpotlightingAnchor = isSpotlight && !isSpotlighing && (spotlightedByAnchorNickname !== anchor.username);

    if (!shouldShowLiveFeed) {
      return null;
    }

    return (
      <div
        className={classnames({
          'anchor-live-feed': true,
          'group-show-feed': isInGroupShow,
          'spotlight-show-feed': isSpotlighing || isSpotlight,
          'broadcast-ended': broadcasterClosedSession,
        })}
        style={{ marginBottom: isTulumRealityShow ? 0 : '', paddingBottom: isTulumRealityShow ? '8px' : '' }}
      >
        <AnchorLiveFeedHeader
          anchor={anchor}
          anchorId={anchorId}
          anchorVideoUrl={anchorVideoUrl}
          broadcasterClosedSession={broadcasterClosedSession}
          canSubscribeToAnchor={canSubscribeToAnchor}
          history={history}
          isAlreadySubscribedToAnchor={isAlreadySubscribedToAnchor}
          isAnchor={isAnchor}
          isBanned={isBanned}
          isGuest={isGuest}
          isInGroupShow={isInGroupShow}
          isSpotlighing={isSpotlighing}
          openContextualOverlay={openContextualOverlay}
          roomCount={roomCount}
          setTippingModal={setTippingModal}
          spotlighedAnchorNickname={spotlighedAnchorNickname}
          spotlighedAnchorUsername={spotlighedAnchorUsername}
          spotlightedByTemptationUsername={spotlightedByTemptationName}
          spotlighterClosedSession={spotlighterClosedSession}
          user={user}
        />
        <div
          className={
            classnames({
              'anchor-live-feed-container': true,
              'bottom-padding': currentAnchorIsNotSpotlightingAnchor,
            })
          }
          style={{ marginBottom: isTulumRealityShow ? 0 : '' }}
        >
          <div className="anchor-live-feed-player-wrapper">
            <AnchorLiveFeedPlayer
              anchorId={anchorId}
              anchorName={anchor.name}
              anchorUsername={anchor.username}
              anchorVideoUrl={anchorVideoUrl}
              broadcasterClosedSession={broadcasterClosedSession}
              hasStreamError={hasStreamError}
              hasStreamViews={hasStreamViews}
              isAlreadySubscribedToAnchor={isAlreadySubscribedToAnchor}
              isAnchor={isAnchor}
              isBanned={isBanned}
              isLivePage={isLivePage}
              isSpotlighing={isSpotlighing}
              isSpotlight={isSpotlight}
              isTulumRealityShow={isTulumRealityShow}
              nsfw={nsfw}
              safeForWatchStatus={safeForWatchStatus}
              setTippingModal={setTippingModal}
              shouldHideVolumeRange={shouldHideVolumeRange}
              slug={slug}
              spotlighedAnchorNickname={spotlighedAnchorNickname}
              spotlighedAnchorUsername={spotlighedAnchorUsername}
              spotlighterClosedSession={spotlighterClosedSession}
              subscribedToOneOfTheAnchors={subscribedToOneOfTheAnchors}
              title={anchor.name}
              toggleStreamLoading={toggleStreamLoading}
              uiStore={uiStore}
              user={user}
              onAllowStreamChangeOnError={onAllowStreamChangeOnError}
              onNetworkError={this.props.onNetworkError}
              onTulumStreamError={onTulumStreamError}
              onLiveSessionEnd={this.onLiveSessionEnd}
            />
          </div>
          <BroadcastChat
            anchor={anchor}
            anchorId={anchorId}
            broadcasting={true}
            changeNsfwFlag={this.changeNsfwFlag}
            chatService={chatService}
            chatServiceTempted={isInGroupShow ? publicChatService : chatServiceTempted}
            guestUser={guestUser}
            isBanned={isBanned}
            isInGroupShow={isInGroupShow}
            isSpotlight={isSpotlight}
            isSpotlighing={isSpotlighing}
            isTulumRealityShow={isTulumRealityShow}
            openContextualOverlay={openContextualOverlay}
            roomCount={roomCount}
            roomUsersCountListener={this.roomUsersCountListener}
            spotlighedAnchorNickname={spotlighedAnchorNickname}
            spotlighedAnchorUsername={spotlighedAnchorUsername}
            spotlightedByAnchorNickname={spotlightedByAnchorNickname}
            streamingSourceType={this.getStreamingSourceType()}
            user={user}
            onBroadcasterClosedSession={this.onBroadcasterClosedSession}
            onSpotlighterClosedSession={this.onSpotlighterClosedSession}
            setSpotlightedByTemptationName={this.setSpotlightedByTemptationName}
          />
        </div>
      </div>
    );
  }
}

export default AnchorLiveFeed;
